import { Dialog } from "primereact/dialog";
import CustomeButton from "~/components/Button";
import { DeleteDirectorModalProps } from "../types/director";

const DeleteDirectorModal = ({
  visible,
  isDeleteLoading,
  deleteHandler,
  closeModal,
}: DeleteDirectorModalProps) => {
  return (
    <Dialog
      visible={visible}
      modal
      className="director-delete-modal"
      onHide={closeModal}
      style={{ width: "46vw" }}
    >
      <div className="director-delete-modal-container flex flex-column gap-2">
        <h3 className="header m-0">
          Are you sure you want to delete this Director Profile?
        </h3>
        <p className="content m-0">
          Deleting will remove the entire director’s profile including all
          associated appointments across this and any linked entities.
        </p>
      </div>

      <div className="action-container mt-2 flex justify-content-end gap-2">
        <CustomeButton label="Cancel" onClick={closeModal} />
        <CustomeButton
          label="Yes, Delete"
          variant="remove"
          loading={isDeleteLoading}
          onClick={deleteHandler}
          disabled={isDeleteLoading}
        />
      </div>
    </Dialog>
  );
};

export default DeleteDirectorModal;
